<template>
  <div class="referral-item -skeleton">
    <div class="referred-member">
      <div class="referral-image">
        <span class="avatar-placeholder demi"></span>
      </div>
      <div class="referral-details">
        <div class="referral-name"></div>
        <div class="referral-date"></div>
      </div>
    </div>
    <div class="referral-reward">
      <div class="reward-amount"></div>
      <div class="reward-complete"></div>
    </div>
  </div>
</template>

<script setup lang="ts"></script>
